module.exports = __webpack_public_path__ + "static/media/order.9cde8474.jpg";